import { render, staticRenderFns } from "./hidden-btn.vue?vue&type=template&id=55d52733&"
import script from "./hidden-btn.vue?vue&type=script&lang=js&"
export * from "./hidden-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports